import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Paper } from "@mui/material";
import { UserPoolThumbnails } from "../userPoolThumbnails/UserPoolThumbnails";

import { initLocalization } from "../../../utils/helpers";
import { creativeClassificationStrings } from "./locale";

export const CreativeClassification = ({
  poolMediaComponent,
  metadataComponent,
  poolData,
  totalPoolSize,
  isLoading,
  selectedCreatives,
  resetSelectedCreatives,
  onCreativesSelection,
  onResetSelectedCreatives,
}) => {
  initLocalization(creativeClassificationStrings);

  const showCreative =
    selectedCreatives.length === 1 && !resetSelectedCreatives;

  return (
    <Paper sx={{ padding: "0.5rem", height: "100%", position: "relative" }}>
      <Grid
        container
        gap="1rem"
        height="100%"
        width="100%"
        direction="row"
        flexWrap="nowrap"
      >
        <Grid flex="0 1 25%">
          <UserPoolThumbnails
            poolData={poolData}
            totalPoolSize={totalPoolSize}
            isLoading={isLoading}
            resetSelectedCreatives={resetSelectedCreatives}
            onCreativesSelection={onCreativesSelection}
            onResetCreativesSelection={onResetSelectedCreatives}
          />
        </Grid>
        <Grid display="flex" flex="0 1 75%">
          {showCreative &&
            selectedCreatives.map((creative) => (
              <Grid
                key={creative.id}
                display="flex"
                flex="1 1"
                flexDirection="column"
                justifyContent="flex-start"
              >
                {poolMediaComponent({ creativeDetails: creative })}
                {metadataComponent({ creativeDetails: creative })}
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Paper>
  );
};

CreativeClassification.propTypes = {
  poolMediaComponent: PropTypes.func.isRequired,
  metadataComponent: PropTypes.func.isRequired,
  poolData: PropTypes.array.isRequired,
  totalPoolSize: PropTypes.number,
  isLoading: PropTypes.bool,
  selectedCreatives: PropTypes.array.isRequired,
  resetSelectedCreatives: PropTypes.bool.isRequired,
  onCreativesSelection: PropTypes.func.isRequired,
  onResetSelectedCreatives: PropTypes.func.isRequired,
};
